// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"107":"9437572b","543":"1cbb14c2"}[chunkId] + ".chunk.css";
};